import { render, staticRenderFns } from "./MarketingActivities.vue?vue&type=template&id=6f0f763b&"
import script from "./MarketingActivities.vue?vue&type=script&lang=js&"
export * from "./MarketingActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports